export default "__VITE_ASSET__16ce86ec__"